import Vue from 'vue';
import Vuex from 'vuex';

// Import different modules
import account from './modules/account/store';
import company from './modules/company/store';
import project from './modules/project/store';
import approval from './modules/approval/store';
import knowledge from './modules/knowledge/store';
import worksheet from './modules/worksheet/store';
import notifications from './modules/notifications/store';
import appMessage from './modules/appMessage/store';

// Utils
import utils from './utils/store';
import VuexPersistence, { AsyncStorage } from 'vuex-persist';
import * as localforage from 'localforage';

Vue.use(Vuex);

interface RootState {
    account: typeof account.state;
    company: typeof company.state;
    project: typeof project.state;
    approval: typeof approval.state;
    knowledge: typeof knowledge.state;
    worksheet: typeof worksheet.state;
    notifications: typeof notifications.state;
    appMessage: typeof appMessage.state;
    utils: typeof utils.state;
}

export default new Vuex.Store({
    plugins: [
        new VuexPersistence<RootState>({
            key: process.env.VUE_APP_STATE_KEY,
            storage: localforage as AsyncStorage,
            asyncStorage: true,
        }).plugin,
    ],

    modules: {
        // All modules
        account,
        appMessage,
        company,
        project,
        approval,
        knowledge,
        worksheet,
        notifications,

        // Utils
        utils,
    },
});
